import { Injectable } from '@angular/core';
import { EMPTY, Observable, TimeoutError } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { ErrorHandlerUtil } from './error-handler.util';
import { catchError, finalize, shareReplay, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class RequestUtil {

    constructor(
        private loaderService: LoaderService,
        private errorHandlerUtil: ErrorHandlerUtil
    ) { }

    public request(observable: Observable<any>, loader = true): Observable<any> {
        if (loader) {
            this.loaderService.addLoader(observable);
        }

        return observable.pipe(
            shareReplay(1),
            finalize(() => {
                if (loader) {
                    this.loaderService.removeLoader(observable);
                }
            }),
            catchError(() => 
            // this.errorHandlerUtil.handleError(error);
                EMPTY
            )
        );
    }

    public requestFromStore<T>(observable: Observable<T>): Observable<T> {
        this.loaderService.addLoader(observable);
        return observable.pipe(
            shareReplay(1),
            tap((result: T) => {
                if (typeof result === 'object' && Object.keys(result).length >= 1) {
                    this.loaderService.removeLoader(observable);
                }
            }),
            catchError((error: HttpErrorResponse | TimeoutError) => {
                this.errorHandlerUtil.handleError(error);
                return EMPTY;
            })
        );
    }
}
